import React, {useEffect, useMemo, useRef, useState} from 'react';
import PropTypes from 'prop-types';
import {DropdownMenu, OptionStyle, SelectDropdownContainer, SelectDropdownStyled} from './SelectDropdown.styled';
import {IconContainer} from '../../core/dropdown/dropdown.styled';
import {CaretIcon} from '../../icons/caret-icon';

export const SelectDropdown = ({selectedValue, cy, disabled, onClick, children}) => {
	const [expanded, setExpanded] = useState(false);
	const buttonGroupRef = useRef();

	const toggleExpanded = () => {
		setExpanded(!disabled && !expanded);
	};

	const selectedOption = useMemo(
		() => React.Children.toArray(children).find(child => selectedValue === child.props.value),
		[children, selectedValue]
	);

	const handleClickOutside = event => {
		if (buttonGroupRef.current && !buttonGroupRef.current.contains(event.target)) {
			setExpanded(false);
		}
	};

	const handleOnClick = value => {
		setExpanded(false);
		onClick(value);
	};

	useEffect(() => {
		// Bind the event listener
		document.addEventListener('click', handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener('click', handleClickOutside);
		};
	});

	return (
		<SelectDropdownContainer data-cy={cy}>
			<SelectDropdownStyled
				onClick={toggleExpanded}
				className={expanded && 'expanded'}
				ref={buttonGroupRef}
				disabled={disabled}
			>
				<span>{selectedOption}</span>
				<IconContainer>
					<CaretIcon
						color={disabled ? '#a1a1a1' : '#4C4C58'}
						direction={expanded ? CaretIcon.DIRECTION.UP : CaretIcon.DIRECTION.DOWN}
						tabIndex="-1"
					/>
				</IconContainer>
			</SelectDropdownStyled>
			{expanded && (
				<DropdownMenu>
					{React.Children.map(children, child => {
						const {value, disabled} = child.props;
						return (
							<OptionStyle onClick={() => !disabled && handleOnClick(value)} disabled={disabled}>
								{child}
							</OptionStyle>
						);
					})}
				</DropdownMenu>
			)}
		</SelectDropdownContainer>
	);
};

SelectDropdown.propTypes = {
	selectedValue: PropTypes.any.isRequired,
	onClick: PropTypes.func.isRequired,
	children: PropTypes.node.isRequired,
	cy: PropTypes.string,
	disabled: PropTypes.bool,
};
